/**
 * Límites y tipos aceptados para los creativos de Ads Studio.
 *
 * POR QUÉ ESTÁ AQUÍ Y NO DUPLICADO (2026-07-29): `CreativeLibrary.jsx` validaba tipo y
 * tamaño; `CreateCampaign.jsx` NO validaba nada. Sólo llevaba
 * `accept=".jpg,.jpeg,.png,.mp4,.mov"` en el input, que es un filtro del selector de
 * archivos, no una validación: un drag-and-drop, un paste o cualquier ruta
 * programática se lo salta. Su cartel ya prometía "Máx 10MB imágenes, 50MB video" y
 * nadie lo hacía cumplir.
 *
 * Se extrae a un módulo en vez de copiar las constantes porque en este repo las copias
 * se desincronizan —hay un check de paridad en el pre-commit precisamente por eso—.
 * Con una sola fuente no hay nada que mantener en paralelo.
 *
 * ⚠️ Esto es validación de CLIENTE: mejora el mensaje de error, no es una barrera de
 * seguridad. Se puede saltar desde la consola del navegador. Hoy nada lo revalida en
 * el servidor: `uploadCreative` recibe `metadata.sizeBytes` del cliente y no comprueba
 * el objeto real. Cuando se implemente la opción B (signed upload URL), la Function
 * que firma es el sitio donde estos mismos límites pasan a ser obligatorios de verdad.
 */

export const ACCEPTED_TYPES = {
  image: ['image/jpeg', 'image/png'],
  video: ['video/mp4', 'video/quicktime'],
};

export const MAX_IMAGE_SIZE = 10 * 1024 * 1024;  // 10 MB
export const MAX_VIDEO_SIZE = 50 * 1024 * 1024;  // 50 MB

/**
 * @param {File} file
 * @returns {{ok: boolean, tipo: 'image'|'video'|null, motivo: 'tipo'|'tamano'|null}}
 *
 * `motivo` distingue los dos rechazos porque el usuario ve mensajes distintos: un
 * formato no soportado y un archivo demasiado grande se arreglan de formas distintas.
 */
export function validarArchivoCreativo(file) {
  if (!file) return { ok: false, tipo: null, motivo: 'tipo' };

  // Por MIME real, no por extensión: renombrar un .exe a .png no lo convierte en imagen.
  const esImagen = ACCEPTED_TYPES.image.includes(file.type);
  const esVideo = ACCEPTED_TYPES.video.includes(file.type);

  if (!esImagen && !esVideo) return { ok: false, tipo: null, motivo: 'tipo' };

  const tipo = esImagen ? 'image' : 'video';
  const tope = esImagen ? MAX_IMAGE_SIZE : MAX_VIDEO_SIZE;

  if (file.size > tope) return { ok: false, tipo, motivo: 'tamano' };

  return { ok: true, tipo, motivo: null };
}
